var React = require('react');

function Letter (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M7 9C6.44772 9 6 9.44772 6 10C6 10.5523 6.44772 11 7 11H12C12.5523 11 13 10.5523 13 10C13 9.44772 12.5523 9 12 9H7Z","fill":"#424242","key":0}),React.createElement("path",{"d":"M6 13C6 12.4477 6.44772 12 7 12H9C9.55228 12 10 12.4477 10 13C10 13.5523 9.55228 14 9 14H7C6.44772 14 6 13.5523 6 13Z","fill":"#424242","key":1}),React.createElement("path",{"d":"M16 9C15.4477 9 15 9.44772 15 10C15 10.5523 15.4477 11 16 11H17C17.5523 11 18 10.5523 18 10C18 9.44772 17.5523 9 17 9H16Z","fill":"#424242","key":2}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M2 7C2 5.89543 2.89543 5 4 5H20C21.1046 5 22 5.89543 22 7V17C22 18.1046 21.1046 19 20 19H4C2.89543 19 2 18.1046 2 17V7ZM4 7H20V17H4V7Z","fill":"#424242","key":3})]);
}

Letter.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Letter;

Letter.default = Letter;
